// Canonical room-stat mapped types.
//
// Room stat mapping is a many-to-many through roomStatMappedTypes (with an
// add/subtract/replace operation) — every report and dashboard rolls stats up
// through that table, never through the legacy roomStatTypes.mappedType scalar.
// These are the values the rollups switch on, so anything outside this list is
// stored but never counted.
export const ROOM_STAT_MAPPED_TYPES = [
  'Available Rooms',
  'Comp Rooms',
  'Day Use Rooms',
  'Down Rooms',
  'No Shows',
  'Occupied Rooms',
  'Rooms Clean',
  'Rooms Dirty',
  'Same Day Arrivals',
  'Stay Overs',
  'Total Guests',
  'Zero Rate Rooms',
];

export default ROOM_STAT_MAPPED_TYPES;
